import React from "react";
import {Link} from "react-router-dom";
import "../../../styles/component/common/quick-actions.scss";

export interface QuickActionsConfig {
    key: string;
    label: string;
    desc: string;
    href: string;
    icon?: React.ElementType;
    color: string;
    bg: string;
}

export interface QuickActionProps {
    title?: string;
    description?: string;
    data: QuickActionsConfig[];
}

function QuickAction(props: QuickActionProps) {
    return (
        <section className="pn__quick-action">
            {
                props.title &&
                <div className="pn__quick-action__header">
                    <h4 className="pn__quick-action__title">{props.title}</h4>
                    <span className="pn__quick-action__description">{props.description}</span>
                </div>
            }

            <div className="pn__quick-action__grid">
                {props.data.map((item: QuickActionsConfig) => {
                    const Icon = item.icon;

                    return (
                        <Link
                            key={item.key}
                            to={item.href}
                            className="pn__quick-action__card"
                            onMouseEnter={e => {
                                (e.currentTarget as HTMLElement).style.borderColor = item.color;
                                (e.currentTarget as HTMLElement).style.boxShadow = '0 4px 12px rgba(0,0,0,0.08)';
                            }}
                            onMouseLeave={e => {
                                (e.currentTarget as HTMLElement).style.borderColor = 'var(--pn-border)';
                                (e.currentTarget as HTMLElement).style.boxShadow = 'none';
                            }}
                        >
                            <div
                                className="pn__quick-action__card-icon"
                                style={{background: item.bg}}
                            >
                                {Icon ?
                                    <Icon size={16} stroke={item.color}/> :
                                    <span style={{color: item.color}}>→</span>
                                }
                            </div>
                            <div className="pn__quick-action__card-label">{item.label}</div>
                            <div className="pn__quick-action__card-description" style={{}}>{item.desc}</div>
                        </Link>
                    )
                })}
            </div>
        </section>
    )
}

export default QuickAction;
